import {
	INFRACTION_API_ORIGIN,
	INFRACTION_DISPLAY_STATUS,
} from "../constants/infraction-api-enums.constant";
import type { InfractionListItem } from "../types/infraction.types";

export function canGeneratePaymentGuideFromListItem(
	item: InfractionListItem
): boolean {
	return (
		item.hasPaymentGuide ||
		item.displayStatus === INFRACTION_DISPLAY_STATUS.PENDING_PAYMENT
	);
}

export function canEditInfractionFromListItem(
	item: InfractionListItem
): boolean {
	return item.origin === INFRACTION_API_ORIGIN.MANUAL;
}
